import React from 'react';
import PropTypes from 'prop-types';
import MuiButton from 'material-ui/Button';
import SaveIcon from '@material-ui/icons/Save';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

const FormFloatingButtons = (props) => (
  <div style={{ position: 'fixed', right: 10, bottom: 10 }}>
    <MuiButton
      variant="raised"
      size="small"
      color="primary"
      style={{ minWidth: 50, width: 50, height: 50, borderRadius: '50%', padding: 10, marginRight: 5 }}
      onClick={props.handleClear}
    >
      <DeleteForeverIcon style={{ fontSize: 25 }} />
    </MuiButton>
    <MuiButton
      variant="raised"
      size="small"
      color="primary"
      style={{ minWidth: 50, width: 50, height: 50, borderRadius: '50%', padding: 10 }}
      onClick={props.handleSave}
    >
      <SaveIcon style={{ fontSize: 25 }} />
    </MuiButton>
  </div>
);

FormFloatingButtons.propTypes = {
  handleSave: PropTypes.func.isRequired,
  handleClear: PropTypes.func.isRequired,
};

export default FormFloatingButtons;



// WEBPACK FOOTER //
// ./src/components/FormFloatingButtons.jsx